export type CampaignBasicInsurance = (typeof CAMPAIGN_BASIC_INSURANCES)[number];
export type CampaignSupplementaryInsurance = (typeof CAMPAIGN_SUPPLEMENTARY_INSURANCES)[number];

export const CAMPAIGN_SUPPLEMENTARY_INSURANCES = [
  'complementary',
  'outpatient',
  'outpatient_comfort',
  'hospital',
  'basic',
  'hospital_capital',
  'dental',
  'accident_disability_capital',
  'accident_death_capital',
  'sickness_death_or_disability_capital',
  'daily_cash',
  'hospital_daily_cash',
  'legal_protection',
] as const;

export const CAMPAIGN_BASIC_INSURANCES = [
  'traditional',
  'managed_care_ham',
  'managed_care',
  'med_direct',
  'casa_nova',
  'tel_doc',
  'med_call',
  'tel_care',
  'combi_care',
  'viva',
  'hmo_plus',
] as const;

export const CAMPAIGN_PRODUCTS = [...CAMPAIGN_SUPPLEMENTARY_INSURANCES, ...CAMPAIGN_BASIC_INSURANCES];

export const CAMPAIGN_PRODUCT_PARAMETER_NAME: string = 'product';
export const CAMPAIGN_FRANCHISE_PARAMETER_NAME: string = 'franchise';
export const CAMPAIGN_INCLUDES_ACCIDENT_COVERAGE_PARAMETER_NAME: string = 'includesAccidentCoverage';
